import { render } from "./WEA-NIS.vue?vue&type=template&id=554af9f9"
import script from "./WEA-NIS.vue?vue&type=script&lang=js"
export * from "./WEA-NIS.vue?vue&type=script&lang=js"

import "./WEA-NIS.vue?vue&type=style&index=0&id=554af9f9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__